import type { Space } from '@cocoonspace/sdk-js/types/space'
import { memo } from 'react'
import { useLingui } from '@lingui/react/macro'

import { PageLoader } from '~/components/page-loader'
import { useAuth } from '~/providers/auth-provider'
import { BOOKING_MAX_DATE } from '../booking-stepper'
import { GuestFooter } from '../guest-footer'
import { StepperHeader } from '../stepper-header'
import { MultidatesProvider, useMultidatesContext } from './provider'
import { StepMultidateCalendar } from './step-multidates-calendar'
import { StepMultidateFooter } from './step-multidates-footer'

export const StepMultidatesContent = () => {
	const { isAuth } = useAuth()
	const { t } = useLingui()
	const { onClickBack, pricesQuery } = useMultidatesContext()

	return (
		<div data-testid='step-multidates'>
			<StepperHeader onClickBack={onClickBack}>
				{t`Date et horaires`}
			</StepperHeader>

			{pricesQuery.isLoading && <PageLoader />}

			{!pricesQuery.isLoading && (
				<StepMultidateCalendar maxDate={BOOKING_MAX_DATE} />
			)}

			{isAuth ? <StepMultidateFooter /> : <GuestFooter />}
		</div>
	)
}

export const StepMultidates = memo(
	({
		space,
		value,
		onClickBack,
	}: {
		space: Space
		value: string[]
		onClickBack: () => void
	}) => (
		<MultidatesProvider
			onClickBack={onClickBack}
			space={space}
			value={value}
		>
			<StepMultidatesContent />
		</MultidatesProvider>
	),
)

StepMultidates.displayName = 'StepMultidates'
